import { useAtomValue, useSetAtom } from 'jotai';
import { FileText } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useCreatedChatArtifacts } from '../../../data/projects/artifacts/createdChatArtifacts';
import {
  openArtifactAtom,
  setOpenArtifactAtom,
} from '../../../data/projects/artifacts/state';
import { HeaderIconButton } from './HeaderIconButton';

import type { JSX } from 'react';

export const CreatedChatArtifactsButton = ({
  projectId,
}: {
  projectId: string;
}): JSX.Element | null => {
  const intl = useIntl();
  const objects = useCreatedChatArtifacts(projectId);
  const artifact = useAtomValue(openArtifactAtom);
  const open = useSetAtom(setOpenArtifactAtom);
  if (!objects.length) return null;
  const label = intl.formatMessage({
    defaultMessage: 'Created in this chat',
    id: 'zHD7hY2g/N',
  });
  const isOpen = artifact?.type === 'created-objects' && artifact.projectId === projectId;
  return (
    <HeaderIconButton
      label={label}
      icon={FileText}
      aria-expanded={isOpen}
      onClick={() => open({ type: 'created-objects', projectId })}
    />
  );
};
